// extracted by mini-css-extract-plugin
export default {"containerGraph":"dashboard_containerGraph__aVSJ4","graph1":"dashboard_graph1__NIaN4"};